module.exports = __webpack_public_path__ + "img/background-3.7d2f7c1c.png";